/* eslint-disable */

// i18n
import i18n from '../../../i18n/i18n'

export default {
  pages: {
    key: "title",
    data: [
      // DASHBOARDS
      {title: i18n.t('Accounts'),        url: "/accounts-number",     icon: "BookIcon",     is_bookmarked: false},
      {title: i18n.t('JournalVoucher'),  url: "/journal-vouchers",    icon: "FileTextIcon", is_bookmarked: false},
      {title: i18n.t('GeneralLedger'),   url: "/general-ledgers",     icon: "BookIcon",     is_bookmarked: false},
      {title: i18n.t('FinancialReport'), url: "/financial-statements", icon: "FileTextIcon",is_bookmarked: false},
      {title: i18n.t('IncomeReport'),    url: "/income-statements",    icon: "FileTextIcon",is_bookmarked: false},
      {title: 'Buku Kas',                url: '/cashbook/mixed-cash',   icon: 'BookIcon',     is_bookmarked: false},
      {title: 'Bon Sementara',           url: '/cash-book-temporary',  icon: 'RepeatIcon',   is_bookmarked: false},
      {title: 'Bank',                    url: '/bank',                  icon: 'CreditCardIcon', is_bookmarked: false},
    ]
  }
}

/* eslint-enable */
